module.exports = __webpack_public_path__ + "img/img15.f1beb0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img15.png
// module id = 191
// module chunks = 0